import { indexGroups } from '@/mocks/home';

const iconMap = [
  'ri-user-follow-line',
  'ri-time-fill',
  'ri-stack-fill',
  'ri-progress-5-line',
];

export default function IndexPanel() {
  return (
    <section
      id="index"
      className="scroll-mt-16 border-y border-secondary-200 bg-background-100"
    >
      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6 md:py-14">
        <div className="text-center">
          <span className="text-stamp text-xs text-primary-600">ARCHIVE INDEX</span>
          <h3 className="font-heading mt-2 text-2xl font-black text-foreground-950 md:text-3xl">
            索引分区 · 想查哪个角度都能快速定位
          </h3>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-600">
            按人物、时段、题材、进度四条路径分仓，先定方向再进专题，避免在海量归档里绕路。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-4 md:mt-8 sm:grid-cols-2 lg:grid-cols-4">
          {indexGroups.map((g, i) => (
            <div
              key={g.name}
              className="flex flex-col rounded-lg border border-secondary-200 bg-background-50 p-5 transition-colors hover:border-primary-200"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-200 text-primary-700">
                <i className={`${iconMap[i]} text-xl`} />
              </span>
              <h4 className="mt-4 text-base font-bold text-foreground-950">{g.name}</h4>
              <p className="mt-1 text-xs text-foreground-500">{g.desc}</p>
              <div className="mt-4 flex flex-wrap gap-2">
                {g.tags.map((t) => (
                  <a
                    key={t}
                    href="#collections"
                    className="whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs text-foreground-700 hover:bg-primary-100 hover:text-primary-800"
                  >
                    {t}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-5 flex flex-col items-center justify-center gap-2 rounded-lg border border-accent-300/60 bg-accent-500/10 px-4 py-3 text-center sm:flex-row">
          <i className="ri-question-line text-accent-700" />
          <p className="text-sm text-foreground-700">
            找不到想要的角度？
          </p>
          <a href="#faq" className="whitespace-nowrap font-medium text-primary-700 hover:text-primary-800">
            先看查证答疑，确认从哪一路进
            <i className="ri-arrow-right-line ml-1" />
          </a>
        </div>
      </div>
    </section>
  );
}